import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, useEffect } from 'react';

import { KnmCollapse } from '../../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupConditionForm } from '../interfaces/IGroupConditionForm';
import { PassportGroupPassportTypeEnum } from '../enums/PassportGroupPassportTypeEnum';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from '../../../UIPackage/MainModule/components/SelectInputField';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { dictionariesItemValuesGet } from '../../../CorePackage/DictionariesModule/actions/dictionariesActions';
import { DictionaryNamesEnum } from '../../../CorePackage/DictionariesModule/enums/DictionaryNamesEnum';
import { getDictionaryEventTypeAllSelectOptions } from '../../../CorePackage/DictionariesModule/selectors/dictionariesSelectors';

interface IEventGroupConditionProps {
  name: string;
  category: IGroupConditionForm['category'];
}

export const EventGroupCondition = ({ name, category }: IEventGroupConditionProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const eventTypeSelectOptions = useSelector(getDictionaryEventTypeAllSelectOptions);

  useEffect(() => {
    dispatch(dictionariesItemValuesGet(DictionaryNamesEnum.EVENT_TYPE));
  }, [dispatch]);

  if (category !== PassportGroupPassportTypeEnum.ERKNM && category !== PassportGroupPassportTypeEnum.PM) {
    return null;
  }

  return (
    <KnmCollapse title="Действия, осуществляемые в рамках КНМ">
      <FieldBlock label="Действия" margin="bottom">
        <SelectInputField
          name={`${name}.eventTypes`}
          options={eventTypeSelectOptions}
          isSearchable
          isMulti
          isClearable
        />
      </FieldBlock>
    </KnmCollapse>
  );
};
